export var KHR_DRACO_MESH_COMPRESSION = 'KHR_draco_mesh_compression';
export var UBER_POINT_CLOUD_EXTENSION = 'UBER_draco_point_cloud_compression';
//# sourceMappingURL=gltf-constants.js.map